var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#04C500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    d: "M5.75 17.166A8.35 8.35 0 0 0 10 18.333c4.584 0 8.334-3.75 8.334-8.334S14.584 1.666 10 1.666s-8.333 3.75-8.333 8.333c0 1.5.417 2.917 1.083 4.167l-.643 2.473a1 1 0 0 0 1.243 1.213z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#04C500",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    d: "M13.75 12.374c0 .135-.03.274-.094.409a1.692 1.692 0 0 1-.871.825q-.339.14-.732.142-.577.001-1.225-.274a6.6 6.6 0 0 1-1.292-.742 11 11 0 0 1-1.232-1.05 11 11 0 0 1-1.047-1.226 6.7 6.7 0 0 1-.737-1.28 3.2 3.2 0 0 1-.27-1.226q0-.384.135-.723.134-.344.432-.626.362-.354.781-.353c.105 0 .21.022.304.067a.6.6 0 0 1 .252.21l.871 1.227q.101.14.15.262a.6.6 0 0 1 .053.229q0 .136-.079.266-.073.131-.21.267l-.285.296a.2.2 0 0 0-.06.15c0 .03.003.056.01.086q.019.044.03.075.102.187.35.48.254.294.545.592c.202.2.398.383.597.552.195.165.357.277.484.345q.03.012.068.03.044.016.094.015a.2.2 0 0 0 .154-.064l.285-.281q.141-.142.27-.21a.5.5 0 0 1 .267-.079.6.6 0 0 1 .23.049q.122.05.262.146l1.243.881a.57.57 0 0 1 .207.24c.037.094.06.188.06.293Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappLight);
export default __webpack_public_path__ + "static/media/whatsappLight.a6ea6ad4d5e0353714a2e4fe767ed1f1.svg";
export { ForwardRef as ReactComponent };